module.exports = __webpack_public_path__ + "img/erwm.9fcc0f75.png";